<template>
  <div>
    <div class="pagelist animate fadeIn">
      <div class="header-pagelist">
        <h1 class="header-title text-center">โอกาสพิเศษที่อยากให้คุณมีส่วนร่วม</h1>
        <h2 class="sub-title text-center">ร่วมบริจาคในโอกาสพิเศษและให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน</h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col col-sm-4 flex">
            <div class="shadow card t-birthday">
              <div class="card-header">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Birthday</h2>
                <div>เฌอปรางค์ อารีย์กุล<br />1 มกราคม </div>
              </div>
              <div class="card-body">
                วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆ มาร่วมบริจาคในโอกาสวันเกิดของเรานะ มาช่วยน้องๆ...
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
          <div class="col col-sm-4 flex">
            <div class="shadow card t-importantday">
              <div class="card-header">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Anniversary</h2>
                <div>อรุณา & วริศ<br />31 มกราคม </div>
              </div>
              <div class="card-body">
                ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงาน... ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงา
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
          <div class="col col-sm-4 flex">
            <div class="shadow card">
              <div class="card-header" style="background-image: url('/static/img/image-preset-event/bg-preset-03@2x.png');">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Time</h2>
                <div>เฌอปรางค์ อารีย์กุล</div>
              </div>
              <div class="card-body">
                วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆ...
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
          <div class="col col-sm-4 flex">
            <div class="shadow card">
              <div class="card-header" style="background-image: url('/static/img/image-preset-event/bg-preset-04@2x.png');">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Anniversary</h2>
                <div>มะนาว นะคะ<br />31 มกราคม </div>
              </div>
              <div class="card-body">
                ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงาน...
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
          <div class="col col-sm-4 flex">
            <div class="shadow card t-birthday">
              <div class="card-header">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Birthday</h2>
                <div>เฌอปรางค์ อารีย์กุล<br />1 มกราคม </div>
              </div>
              <div class="card-body">
                วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆาช่วยน้องๆ...
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
          <div class="col col-sm-4 flex">
            <div class="shadow card">
              <div class="card-header" style="background-image: url('/static/img/image-preset-event/bg-preset-05@2x.png');">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Anniversary</h2>
                <div>อรุณา & วริศ<br />31 มกราคม </div>
              </div>
              <div class="card-body">
                ครบรอบแต่งงานของเราปีนี้ อยากทำสิ่งที่พิเศษมากกว่าปีก่อนๆ อยากชวนเพื่อนมาร่วมบริจาคในโอกาสครบรอบแต่งงาน...
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
          <div class="col col-sm-4 flex">
            <div class="shadow card t-importantday">
              <div class="card-header">
                <img class="img-circle" src="../assets/img/profile-mockup.png" alt="people" />
                <h2 class="card-title">Happy Aniversary</h2>
                <div>เฌอปรางค์ อารีย์กุล<br />1 มกราคม </div>
              </div>
              <div class="card-body">
                วันเกิดของเราปีนี้เราขอทำสิ่งพิเศษกว่าปีที่ผ่านมา เราขอชวนพื่อนๆ มาร่วมบริจาคในโอกาสวันเกิดของเรานะ มาช่วยน้องๆ...
              </div>
              <div class="card-footer">
                <funding-goal class="mb-20"></funding-goal>
                <button type="button" class="ma-auto btn btn--default btn--full">ร่วมบริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FundingGoal from './FundingGoal.vue'
  export default {
    components: {
      FundingGoal
    }
  }
</script>

<style scoped lang="scss">
.pagelist {
  background: #F2F2F4 url("../assets/img/bg-grey_hex.png") no-repeat top center;
  background-size: 100%;
  @media all and (max-width: 767px) {
    .container {
      max-width: 360px;
    }
  }

  .row {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    flex-wrap: -webkit-flex-wrap;
  }

  .header-pagelist {
    padding: 1em 0 1.5em;
    h1,h2 { color: #242424 }
  }

  .card {
    background: #fff;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
  }

  .card-header {
    background: #fff url("/static/img/image-preset-event/bg-preset-03@2x.png") no-repeat top center;
    background-size: cover;
    text-align: center;
    padding: 1em;
    color: #242424;
    .card-title {
      font-family: mitr, sans-serif;
      color: #242424;
      font-weight: 500;
      font-size: 20px;
      margin-bottom: 0.5em;
      @media all and (min-width: 1023px) {
        font-size: 23px;
      }
    }
  }
    .img-circle {
      border-radius: 50%;
      width: 170px;
      height: 170px;
      display: inline-block;
      border: 5px solid #fff;
      margin-bottom: 1em;
      box-sizing: border-box;
    }

  .card-body {
    background: #fff;
    padding: 1em;
    border-bottom: 1px solid #C7D2D7;
    font-size: 15px;
    line-height: 1.4em;
    @media all and (min-width: 1023px) {
      font-size: 17px;
    }
  }

  .card-footer {
    background: #fff;
    padding: 1em;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
    flex: 1 0 auto;
  }

  /* Birthday Type */
  .t-birthday {
    .card-header {
      background: #fff url("/static/img/image-preset-event/bg-preset-01@2x.png") no-repeat top center;
      background-size: cover;
      color: #fff;
      .card-title { color: #fff; }
    }
  }
  /* วันสำคัญ Type */
  .t-importantday {
    .card-header {
      background: #fff url("/static/img/image-preset-event/bg-preset-02@2x.png") no-repeat top center;
      background-size: cover;
      color: #242424;
      .card-title { color: #242424; }
    }
  }

}

</style>



// WEBPACK FOOTER //
// PageList.vue?291a520e